import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-between",
  "use": "icon-between-usage",
  "viewBox": "0 0 14.1 4.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14.1 4.3\" id=\"icon-between\">\r\n<polygon points=\"0,4.3 0,2.9 9.9,2.9 7.6,1.2 8.4,0 14.1,4.3 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol